module.exports = __webpack_public_path__ + "img/pay7@2x.537a9413.png";